export enum GatheringType {
  OPEN_HOUSE = 'open_house',
  PLAY_DATE = 'play_date',
  ARTS_AND_CRAFTS = 'arts_and_crafts',
  MUSIC_CIRCLE = 'music_circle',
  READING_CIRCLE = 'reading_circle',
  PETTING_ZOO = 'petting_zoo',
  GROUP_TOUR = 'group_tour',
  OTHER = 'other',
}

const PRE = 'DASHBOARD-INTERESTED-MARKETING-EVENT'

export function humanReadableGatheringType(type: GatheringType) {
  switch (type) {
    case GatheringType.OPEN_HOUSE:
      return `${PRE}-OPEN-HOUSE`
    case GatheringType.PLAY_DATE:
      return `${PRE}-OPEN-HOUSE-PLAY-DATE`
    case GatheringType.ARTS_AND_CRAFTS:
      return `${PRE}-OPEN-HOUSE-ARTS`
    case GatheringType.MUSIC_CIRCLE:
      return `${PRE}-OPEN-HOUSE-MUSIC-CIRCLE`
    case GatheringType.READING_CIRCLE:
      return `${PRE}-OPEN-HOUSE-READING-CIRCLE`
    case GatheringType.PETTING_ZOO:
      return `${PRE}-OPEN-HOUSE-PETTING-ZOO`
    case GatheringType.GROUP_TOUR:
      return `${PRE}-GROUP-TOUR`
    default:
      return `${PRE}-UPCOMING-EVENT`
  }
}
